/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'

import flatMap from 'lodash/flatMap'
import isNil from 'lodash/isNil'
import map from 'lodash/map'
import uniqBy from 'lodash/uniqBy'

import { getAllMilkQualities } from '@smartcoop/services/apis/smartcoopApi/resources/dairyFarm'

const MILK_QUALITIES_FIELDS = [
  'milkQualityId', 'dairyFarmId', 'ccs', 'ctb', 'ccsLimit', 'ctbLimit',
  'organizationId', 'manual', 'userDocument', 'date','protein', 'fat', 'proteinLimit',
  'fatLimit', 'userStateRegistrationId', 'nul', 'lactose', 'groupedItems', 'createdAt', 'updatedAt'
]

export function milkQualitiesService(database) {
  async function createOrUpdate(milkQualities = []) {
    await database.write(async () => {
      const promises = milkQualities.map((milkQuality) => async () => {
        const register = await database.get('milkQualities')
          .query(Q.where('milkQualityId', milkQuality?.milkQualityId || milkQuality?.id))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        if(milkQuality?.deletedAt) {
          return
        }
        await database.get('milkQualities').create((item) => {
          MILK_QUALITIES_FIELDS.forEach((field) => {
            if(
              field === 'groupedItems'
            ) {
              item[field] = JSON.stringify(milkQuality[field])
            }
            if(field === 'milkQualityId') {
              item[field] = milkQuality?.milkQualityId || milkQuality?.id
            } else {
              item[field] = milkQuality[field]
            }
          })
        })
      })

      await Promise.all(promises.map((fn) => fn()))
    })
  }

  async function deleteMilkQualityById(milkQualityId) {
    await database.write(async () => {
      const register = await database.get('milkQualities')
        .query(Q.where('milkQualityId', milkQualityId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('milkQualities').query().destroyAllPermanently()
    })
  }

  async function findMilkQualityById(milkQualityId) {
    return database
      .get('milkQualities')
      .query(Q.where('milkQualityId', milkQualityId))
      .fetchOne()
  }

  function observeMilkQualities(dairyFarmId = null) {
    const milkQualitiesCollection = database.collections.get('milkQualities')

    return milkQualitiesCollection.query(
      Q.where('dairyFarmId', Q.eq(dairyFarmId))
    ).observe()
  }

  async function syncMilkQualities(params) {
    const { data: response } = await getAllMilkQualities(
      { ...params, limit: 999999 }
    )

    const updatedList = flatMap(response, (grouped) => flatMap(grouped?.data, (item) => ({ ...item, dairyFarmId: grouped?.dairyFarmId })))

    const data = map(updatedList, (item) => {
      const groupedItems = []
      const addGroup = (fieldName) => {
        groupedItems.push({
          date: item.date,
          type: fieldName,
          result: item[fieldName],
          limit: item[`${ fieldName  }Limit`]
        })
      }

      if (!isNil(item.ccs)) addGroup('ccs')
      if (!isNil(item.ctb)) addGroup('ctb')
      if (!isNil(item.nul)) addGroup('nul')
      if (!isNil(item.protein)) addGroup('protein')
      if (!isNil(item.fat)) addGroup('fat')
      if (!isNil(item.lactose)) addGroup('lactose')

      return {
        ...item,
        groupedItems
      }
    })
    await createOrUpdate(uniqBy(data, 'id'))
  }

  return {
    createOrUpdate,
    clearTable,
    deleteMilkQualityById,
    findMilkQualityById,
    observeMilkQualities,
    syncMilkQualities
  }
}